import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
dayjs.extend(customParseFormat);
export const isDateValid = (date, format = 'YYYY-MM-DD') => {
    return dayjs(date, format, true).isValid();
};
//# sourceMappingURL=isDateValid.js.map